import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRoomContext } from '../../../RoomContext';
import HomeMeetingView from './HomeMeetingView';
import SerivceName from './SerivceName';
import { ROOM_TALKING } from '../../../const';
import * as bottomNavigationActions from '../../../actions/bottomNavigationActions';
import {
	peersLengthSelector
} from '../../Selectors';

const styles = () =>
	({
		root :
		{
			height          : 'calc(100% - 100px)',
			aspectRatio     : 1.777,
			maxWidth        : '96vw',
			minWidth        : 1000,
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			borderRadius    : '20px',
			backgroundColor : '#e5e5e2',
			padding         : '2%',
			justifyContent  : 'space-between'
		},
		rootTalking :
		{
			height          : 'calc(100% - 100px)',
			aspectRatio     : 1.777,
			maxWidth        : '98vw',
			minWidth        : 800,
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			borderRadius    : '20px',
			backgroundColor : '#e5e5e2',
			padding         : '1%',
			justifyContent  : 'flex-start'
		}
	});

const CallPage = ({
	roomClient,
	room,
	classes,
	peersLength,
	setNaviTab
}) =>
{
	useEffect(() =>
	{
		if (peersLength === 0)
		{
			setNaviTab('home');
		}
	}, [
		peersLength,
		setNaviTab
	]);

	return (
		<div className={classes.rootTalking}>
			<SerivceName />
			{ (room.info && room.info.status === ROOM_TALKING) &&
				<HomeMeetingView roomClient={roomClient} />
			}
		</div>
	);
};

CallPage.propTypes =
{
	roomClient  : PropTypes.object.isRequired,
	room        : PropTypes.object.isRequired,
	classes     : PropTypes.object.isRequired,
	peersLength : PropTypes.number.isRequired,
	setNaviTab  : PropTypes.func.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		room        : state.room,
		peersLength : peersLengthSelector(state)
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		setNaviTab : (tab) =>
		{
			dispatch(bottomNavigationActions.setNaviTab(tab));
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room
			);
		}
	}
)(withStyles(styles)(CallPage)));